const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const getConsentDisplayTitle = (title: string, version?: string | null) => {
    const normalizedTitle = title.trim();
    const normalizedVersion = version?.trim();

    if (!normalizedVersion) {
        return normalizedTitle;
    }

    const compactVersion = normalizedVersion.replace(/(?:\.0)+$/, "");
    const versionSuffixes = Array.from(new Set([normalizedVersion, compactVersion].filter(Boolean)));
    const titleWithoutVersion = versionSuffixes.reduce(
        (currentTitle, versionSuffix) =>
            currentTitle.replace(new RegExp(`\\s+v${escapeRegExp(versionSuffix)}$`, "i"), ""),
        normalizedTitle,
    );

    return titleWithoutVersion.trim() || normalizedTitle;
};
